/* eslint-disable */
import * as token from "./token";
import { client } from "./client";
import * as payments from "./payments";
import * as partners_payments from "./partners_payments";
import * as deposits from "./deposits";
import * as anticipations from "./anticipations";
import * as account from "./account";
import * as dashboard from "./dashboard";
import * as tickets from "./tickets";
import * as wallet from "./wallet";
import * as invoices from "./invoices";
import * as chargebacks from "./chargebacks";
import * as recharges from "./recharges";
import * as partners from "./partners";
import * as login from "./login";
import * as correios from "./correios";
import * as team from "./team";
import paylinks from "./paylinks";

const recovery = email => {
  return client.post("passwords/recovery-password", { email: email });
};

const updatePasswordByToken = (data) => {
  return client.post("passwords/update-by-token", data);
};

const getPartnerInfoByToken = (token) => {
  return client.get(`passwords/partner-info?token=${token}`);
};

/* eslint-enable */

export default {
  token,
  client,
  login,
  recovery,
  updatePasswordByToken,
  getPartnerInfoByToken,
  payments,
  deposits,
  anticipations,
  dashboard,
  account,
  tickets,
  wallet,
  invoices,
  chargebacks,
  recharges,
  partners,
  partners_payments,
  correios,
  team,
  paylinks
};
